/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";

const Dialog = require("@react/react-spectrum/Dialog").default;

class OrganizeErrorHandlingDialog extends Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;
    return (
      <Dialog
        title={formatMessage({ id: "error.handling.passwordProtected" })}
        onConfirm={this.props.onConfirm}
        onClose={this.props.onCancel}
        confirmLabel={formatMessage({ id: "error.handling.passwordProtected.confirm" })}
        cancelLabel={formatMessage({ id: "delete.page.dialog.cancel" })}
        autoFocusButton="confirm"
      >
        <p>{formatMessage({ id: "error.handling.passwordProtected.description" })}</p>
      </Dialog>
    );
  }
}

export { OrganizeErrorHandlingDialog };
